import { jsx } from "react/jsx-runtime";
import { AccountDrawerAuth } from "./AccountDrawerAuth/index.js";
import { withContentstack } from "./withContentstack.js";
const COMPONENT_NAME = "AccountDrawer";
const AccountDrawer = async (props) => {
  const AccountDrawerServer = withContentstack(AccountDrawerAuth);
  return /* @__PURE__ */ jsx(AccountDrawerServer, { ...props });
};
AccountDrawer.displayName = COMPONENT_NAME;
export {
  AccountDrawer
};
